import { createTableData, startGameListenerN } from '@/Poker/redux/slices/gameTableSlice';
import { generateUniqueId } from '../../../Common/utils/PokerUtils';
import TableUtils from '@/Poker/utils/TableUtils';
import { useDispatch } from 'react-redux';
import store from '@/Poker/redux/store';
import { useLocation, useNavigate } from 'react-router';
import useActiveGames from '../data/useActiveGames';
import useLobby, { useChannel } from '../data/useLobby';
import { toast } from 'sonner';

export default function useCreateGame() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const channel = useChannel();
    const activeGames = useActiveGames();
    const location = useLocation();

    // This is the function to create new table
    const initiateCreateTable = (gameDefinition, tableId = null, joinSimilar = false, quickJoin = false) => {

        let roomId = gameDefinition.roomId;
        let roomDetails = store.getState().lobby.masterRoomsObject[roomId];
        let isTableListingEnabled = gameDefinition?.tableListingChannel.includes(channel) && roomDetails.isTableListingEnabled || tableId;

        try {
            if (activeGames.length === 4) {
                console.warn('4 active games already running. Cannot create another. ')
                toast.info('Max table limit reached. Please leave one of your tables to join a new one')
                return
            }
            console.log('Initiating create table process...');
            let tempTableId = generateUniqueId();
            console.log('Generated tempTableId:', tempTableId);

            let joinType = 'AutoJoin';
            if (isTableListingEnabled && tableId) {
                // Manual Join
                joinType = 'NA';
            } else if (joinSimilar) {
                // Join Similar
                joinType = 'JoinSimilar';
            } else if (quickJoin) {
                // Quick Join
                joinType = 'QuickJoin';
            }

            dispatch(
                createTableData({
                    tempTableId: tempTableId,
                    gameDefinition: gameDefinition,
                    manualTableId: tableId ? tableId : null,
                    watchPlayer: true,
                    joinType,
                    isTableListingEnabled,
                })
            );
            console.log('Dispatched createTableData action.');

            dispatch(
                startGameListenerN({
                    store: store,
                    tempTableId: tempTableId,
                    dispatchFunction: dispatch,
                })
            );
            console.log('Dispatched startGameListenerN action.');

            let isTableObserverCreated = TableUtils.getInstance(store).addTableObserver(
                store,
                tempTableId,
                gameDefinition.gameDefId,
                dispatch
            );
            console.log('Table observer creation status:', isTableObserverCreated);

            if (isTableObserverCreated) {
                console.log('Table observer created successfully.');
                TableUtils.getInstance().updateGameConnectionStatus(
                    tempTableId,
                    false,
                    true
                );
                console.log('Updated game connection status.');

                TableUtils.getInstance().passGameToSequential(tempTableId, "add", true);
                console.log('Passed game to sequential.');
            }

            navigate(`/game`, {
                replace: location.pathname === '/game'
            })
        } catch (err) {
            console.error('Error in creating game table >> ', err);
        }
    };

    const createLackTable = (currentLackGame, masterGameDefinitions, privateTableActiveGameDefinitions) => {
        try {
            if (activeGames.length === 4) {
                console.warn('4 active games already running. Cannot create another. ')
                return
            }
            console.log('Initiating create table process...');
            let tempTableId = generateUniqueId();
            console.log('Generated tempTableId:', tempTableId);

            dispatch(
                createTableData({
                    tempTableId: tempTableId,
                    gameDefinition: currentLackGame.isPrivateTable
                        ? privateTableActiveGameDefinitions[currentLackGame.gameDefId]
                        : masterGameDefinitions[currentLackGame.gameDefId],
                    lackGameId: currentLackGame.gameId,
                    lackTableId: currentLackGame.tableId,
                    awsalbcookie: currentLackGame.awsALBCookie,
                    gameEndpoint: currentLackGame.nodeIp,
                    isTourneyGame: false,
                    isTourneyLackGame: false,
                    watchPlayer: true,
                    isPrivateTable: currentLackGame.isPrivateTable,
                })
            );
            //console.log('Spruha log >>> Dispatched createTableData action.');
            //console.log('Spruha log >>> Starting GameListener N')
            dispatch(
                startGameListenerN({
                    store: store,
                    tempTableId: tempTableId,
                    dispatchFunction: dispatch,
                })
            );
            //console.log('Spruha log >>> Dispatched startGameListenerN action.');
            //console.log('Spruha log >>> Table Utils Invoking Observer')


            // const gameDefinition = useSelector(
            //     (state) => state.gameTable.games[tempTableId].gameDefinition
            //   );

            let isTableObserverCreated = TableUtils.getInstance(store).addTableObserver(
                store,
                tempTableId,
                currentLackGame.gameDefId,
                dispatch
            );
            //console.log('Spruha log >>> Table observer creation status:', isTableObserverCreated);
            if (isTableObserverCreated) {
                //console.log('Spruha log >>> Table observer created successfully.');
                TableUtils.getInstance().updateGameConnectionStatus(
                    tempTableId,
                    false,
                    true
                );
                //console.log('Spruha log >>> Updated game connection status.');

                TableUtils.getInstance().passGameToSequential(tempTableId, "add", true);
                console.log('Passed game to sequential.');
            }

            navigate(`/game`, {
                replace: location.pathname === '/game'
            })
        } catch (err) {
            console.error('Error in creating game table >> ', err);
        }
    }

    const createTourneyLackTable = (currentLackTourneyGame, currentLackTourneyGameDefinition) => {
        try {

            if (activeGames.length === 4) {
                console.warn('4 active games already running. Cannot create another. ')
                return
            }
            let isActiveTourneyWithSameIdAvailable = false;
            console.log('Initiating create table process...');
            if (
                currentLackTourneyGameDefinition &&
                !currentLackTourneyGameDefinition.watchPlayer
            ) {
                // activeGames
                for (let gameData in activeGames) {
                    //   let tempTableId = activeGameIds[game];

                    if (
                        gameData.isTourneyGame &&
                        !gameData.watchPlayer &&
                        gameData.gameDefinition.tourneyId ===
                        currentLackTourneyGameDefinition.tourneyId
                    ) {
                        isActiveTourneyWithSameIdAvailable = true;
                    }
                }
            }

            let tempTableId = generateUniqueId();
            console.log('Generated tempTableId:', tempTableId);

            if (
                currentLackTourneyGameDefinition &&
                !isActiveTourneyWithSameIdAvailable &&
                currentLackTourneyGame &&
                currentLackTourneyGame?.domainName
            ) {
                dispatch(
                    createTableData({
                        tempTableId: tempTableId,
                        gameDefinition: {
                            ...currentLackTourneyGameDefinition,
                            gameDefId: `${Math.floor(Math.random() * 49000)}`, //NOTE: For tourney we dont have any game def id so for that we are sending it a number , and it should be less than 50,000 value , can send any unique  random number ranges from 0 to50k
                        },
                        lackGameId: currentLackTourneyGame?.isTourneyLackGame
                            ? `${Math.floor(Math.random() * 49000)}`
                            : currentLackTourneyGame.gameId,
                        lackTableId: currentLackTourneyGame.tableId,
                        awsalbcookie: null,
                        gameEndpoint: currentLackTourneyGame.domainName,
                        isTourneyGame: true,
                        isTourneyLackGame: true,
                        watchPlayer: currentLackTourneyGame.watchPlayer
                            ? currentLackTourneyGame.watchPlayer
                            : false,
                        isPrivateTable: false,
                    })
                );

                dispatch(
                    startGameListenerN({
                        store: store,
                        tempTableId: tempTableId,
                        dispatchFunction: dispatch,
                    })
                );

                let gameDefinition = store.getState().gameTable?.games[tempTableId].gameDefinition;



                let isTableObserverCreated = TableUtils.getInstance(store).addTableObserver(
                    store,
                    tempTableId,
                    gameDefinition?.gameDefId,
                    dispatch
                );
                //console.log('Spruha log >>> Table observer creation status:', isTableObserverCreated);
                if (isTableObserverCreated) {
                    //console.log('Spruha log >>> Table observer created successfully.');
                    TableUtils.getInstance().updateGameConnectionStatus(
                        tempTableId,
                        false,
                        true
                    );
                    //console.log('Spruha log >>> Updated game connection status.');

                    TableUtils.getInstance().passGameToSequential(tempTableId, "add", true);
                    console.log('Passed game to sequential.');
                }

                navigate(`/game`, {
                    replace: location.pathname === '/game'
                })

            }

            // navigate(`/game`)
        } catch (err) {
            console.error('Error in creating game table >> ', err);
        }
    }

    return { initiateCreateTable, createLackTable, createTourneyLackTable };
}
